/* Cálculo de tendencia semanal real a partir de los datos crudos que devuelve getStatusTrends
   (una fila por id_status/día, para los últimos 14 días). Todo se deriva de datos reales del
   backend: si no hay semana anterior con la que comparar, el % de cambio se omite (null) en vez
   de inventarse. El sparkline sí se puede mostrar siempre: la ausencia de una fila para un día
   significa 0 transiciones reales ese día (getStatusTrends agrupa con COUNT, no rellena ceros). */

export interface IStatusTrendRow {
  id_status: number
  day: string // 'YYYY-MM-DD'
  cantidad: number | string
  monto: number | string
}

export interface ITrendResult {
  /* null cuando la semana anterior no tiene datos reales con qué comparar (no se puede calcular
     un % de cambio real, así que se omite en vez de fabricarlo). */
  pctChange: number | null
  /* últimos 7 días, en orden cronológico, siempre calculable a partir de las filas reales. */
  sparkline: number[]
}

const toDayString = (d: Date): string => {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const last7Days = (): string[] => {
  const today = new Date()
  const days: string[] = []
  for (let i = 6; i >= 0; i--) {
    const d = new Date(today)
    d.setDate(today.getDate() - i)
    days.push(toDayString(d))
  }
  return days
}

export const computeTrend = (
  rows: IStatusTrendRow[],
  matchesStatus: (idStatus: number) => boolean,
  field: 'cantidad' | 'monto'
): ITrendResult => {
  const filtered = rows.filter((row) => matchesStatus(row.id_status))
  const days = last7Days()
  const currentWeekStart = days[0]

  const byDay = new Map<string, number>()
  let currentTotal = 0
  let previousTotal = 0

  filtered.forEach((row) => {
    const value = Number(row[field] ?? 0)
    if (row.day >= currentWeekStart) {
      currentTotal += value
      byDay.set(row.day, (byDay.get(row.day) ?? 0) + value)
    } else {
      previousTotal += value
    }
  })

  const sparkline = days.map((day) => byDay.get(day) ?? 0)
  const pctChange = previousTotal > 0 ? ((currentTotal - previousTotal) / previousTotal) * 100 : null

  return { pctChange, sparkline }
}
